export const applicantsTableHeader = [
    'فارم نمبر',
    'درخواست دہندہ',
    'والد کا نام',
    'درجہ',
    'موبائل',
    'شناختی کارڈ',
    'تفصیلات دیکھیں',
    'ریکاڈ حذف کریں',
];
export const studentsTableHeader = [
    'رجسڑیشن نمبر',
    'طالب علم',
    'والد کا نام',
    'درجہ',
    'موبائل',
    'شناختی کارڈ',
    'تفصیلات دیکھیں',
    'ریکاڈ حذف کریں',
];
export const teachersTableHeader = [
    'تعداد',
    'نام',
    'ولدیت',
    'موبائل',
    'شناختی کارڈ',
    'تفصیلات دیکھیں',
    'ریکاڈ حذف کریں',
];
export const attendancesTableHeader = [
    'تعداد',
    'طالب علم',
    'درجہ',
    'سیکشن',
    'یومیہ حاضری کی تعداد ',
    'کل حاضری',
];
export const classesTableHeader = [
    'تعداد',
    'شعبہ',
    'کلاسز کے نام',
    'سیکشنز کی تعداد',
    'یومیہ حاضری کی تعداد',
    'ترمیم کریں',
    'ریکاڈ حذف کریں',
    ' کلاسز کا نام (انگلش) ',
];
export const subjectsTableHeader = ['تعداد', 'مضامین کے نام', 'ترمیم کریں', 'ریکاڈ حذف کریں'];
